import {
  AbsoluteSize,
  Size,
} from '@app/features/apply-react-signing/components/FieldRenderer/types';

export function createAbsoluteSize(size: Size): AbsoluteSize {
  return size as AbsoluteSize;
}
